module.exports = __webpack_public_path__ + "img/bootstrap-fill.62b717c3.svg";